





import openApp from '@ivy/fts/openApp'
import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
@Component
export default class FixedBottom extends Vue {
  appDown() {
    return openApp()
  }
}
